export enum MODAL_TRIGGER {
  CANCEL = 'cancel',
  CONFIRM = 'confirm',
  BUTTON = 'button',
  CLOSE = 'close',
}

export enum MODAL_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const MODAL_WIDTH_BY_SIZE = {
  [MODAL_SIZE.SMALL]: 424,
  [MODAL_SIZE.MEDIUM]: 600,
  [MODAL_SIZE.LARGE]: 1020,
};
